module.exports = __webpack_public_path__ + "static/media/missions-icon-arrow.c983e5a1.png";